import { render, staticRenderFns } from "./DomainDetailsTab.vue?vue&type=template&id=a4819abc&scoped=true&"
import script from "./DomainDetailsTab.vue?vue&type=script&lang=js&"
export * from "./DomainDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4819abc",
  null
  
)

export default component.exports